import { createSelector } from 'reselect';
import { customerSlotSelector, hasBookedSlot } from '.';

export const getCustomerSlotStartDateTime = createSelector(
  [customerSlotSelector, hasBookedSlot],
  (customerSlot, customerHasSlot) => (customerHasSlot ? customerSlot.slotStartDateTime : undefined),
);

export const getCustomerSlotEndDateTime = createSelector(
  [customerSlotSelector, hasBookedSlot],
  (customerSlot, customerHasSlot) => (customerHasSlot ? customerSlot.slotEndDateTime : undefined),
);
